<template>
  <div>
    <div class="sidebar-cnt" :class="{ hide: menuHide }">
      <v-icon class="icon-menu" :class="{ hide: menuHide }" @click="hideMenu()"
        >sort</v-icon
      >
      <div class="side-menu" :class="{ hide: menuHide }">
        <ul id="main-menu">
          <li class="active" id="own" @click="anchorNav('own')">
            {{$t("views.channels.own")}}
          </li>
          <ul>
            <li id="web" @click="anchorNav('web')">
              {{$t("views.channels.web")}}
            </li>
            <li id="reports" @click="anchorNav('reports')">
              {{$t("views.channels.reports")}}
            </li>
            <li id="offers" @click="anchorNav('offers')">
              {{$t("views.channels.offers")}}
            </li>
            <li id="rrss" @click="anchorNav('rrss')">
              {{$t("views.channels.rrss")}}
            </li>
          </ul>
          <li id="paid" @click="anchorNav('paid')">
            {{$t("views.channels.paid")}}
          </li>
          <ul>
            <li id="briefing" @click="anchorNav('briefing')">
              {{$t("views.channels.briefing")}}
            </li>
          </ul>
        </ul>
      </div>
      <!-- <div class="print" :class="{ hide: menuHide }" @click="printPage()"><v-icon color="var(--secondary_color)" v-if="menuHide">print</v-icon><span v-if="!menuHide">Imprimir informe</span></div> -->
    </div>
    <div class="content" :class="{ hide: menuHide }">
      <div ref="own" class="own">
        <div class="title area">
          {{$t("views.channels.own")}}
        </div>

        <div class="web section" ref="web">
          <span class="title">{{$t("views.channels.web")}}</span>
          <span class="sec-description"
            >{{$t("views.channels.description.web")}}</span
          >

          <div class="part form">
            <div class="alert" :class="{ show: changesDetected.open }">
              {{$t("views.channels.pending")}}
            </div>

            <div class="part opening" :class="{ closed: temp_opening == 0 }">
              <div class="question q1">
                <div class="label">
                  {{$t("views.channels.question.opening")}}
                </div>

                <v-radio-group
                  v-model="temp_opening"
                  @change="changesDetected.open = true"
                >
                  <v-layout wrap>
                    <v-flex>
                      <v-radio label="Si" value="1" color="#004412"></v-radio>
                    </v-flex>

                    <v-flex md3>
                      <v-radio label="No" value="0" color="#d42525"></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </div>

              <div class="open_date" v-if="temp_opening == 0">
                <div class="label">
                  {{$t("views.channels.question.day")}}
                </div>
                <input
                  type="date"
                  v-model="temp_opening_date"
                  @change="
                    changesDetected.open = true;
                    errorTemp_opening = false;
                  "
                  :class="{ error: errorTemp_opening }"
                />
                <div class="opening_motive" v-if="temp_opening == 0">
                  <div class="label">
                    {{$t("views.channels.question.motive")}}
                  </div>
                  <v-select
                    :items="openingMotiveItems"
                    item-text="name"
                    item-value="value"
                    v-model="temp_opening_motive"
                    @change="
                      changesDetected.open = true;
                      errorTemp_opening_motive = false;
                    "
                    :class="{ error: errorTemp_opening_motive }"
                  ></v-select>
                </div>
              </div>
            </div>

            <span class="title subarea">
              {{$t("views.channels.information")}}
            </span>

            <div class="alert" :class="{ show: changesDetected.info }">
              {{$t("views.channels.pending")}}
            </div>

            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex md4>
                  <v-text-field
                    label="Site"
                    disabled
                    v-model="selectedLocation.site"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-select
                    :label="$t('general.restaurant_mode')"
                    item-text="name"
                    item-value="value"
                    :items="[
                      { value: 1, name: 'Mall' },
                      { value: 2, name: 'InStore' },
                      { value: 3, name: 'Free-Standing' },
                      { value: 4, name: 'Easy' }
                    ]"
                    disabled
                    v-model="type"
                  ></v-select>
                </v-flex>

                <v-flex md4>
                  <v-select
                    :label="$t('general.region')"
                    item-text="name"
                    item-value="value"
                    disabled
                    :items="[
                      { value: 1, name: 'Nor Oeste' },
                      { value: 2, name: 'Centro' },
                      { value: 3, name: 'Este' },
                      { value: 4, name: 'Levante' },
                      { value: 5, name: 'Sur' },
                      { value: 6, name: 'McOpCo' }
                    ]"
                    v-model="region"
                  ></v-select>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.public_name')"
                    v-model="name"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.address')"
                    v-model="address"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.opening_date')"
                    v-model="log_date"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <!-- <v-flex md4>
                  <v-checkbox
                    label="Quieren recibir CV"
                    v-model="cv_public"
                    @change="
                      change = true;
                      changesDetected.info = true;
                    "
                    color="#004412"
                  ></v-checkbox>
                </v-flex>

                <v-flex md4>
                  <v-checkbox
                    label="Quieren recibir CV de Personal de equipo"
                    v-model="cv_team"
                    @change="
                      change = true;
                      changesDetected.info = true;
                    "
                    color="#004412"
                  ></v-checkbox>
                </v-flex> -->

                <div class="form-section">
                  {{$t("general.contact")}}
                </div>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.phone')"
                    v-model="phone"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.email')"
                    v-model="email"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <div class="form-section">
                  {{$t("views.channels.fiscal_data")}}
                </div>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.razon')"
                    v-model="razon"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.cif')"
                    v-model="CIF"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>

                <v-flex md4>
                  <v-text-field
                    :label="$t('views.channels.fiscal_address')"
                    v-model="fiscal_address"
                    @change="change = true"
                    @input="changesDetected.info = true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="help">
            {{$t("views.channels.help")}}
          </div>
          <div class="tabs">
            <div
              class="tab"
              :class="{ active: !selectedPlanned }"
              @click="selectedPlanned = false"
            >
              <div class="error-circle" v-if="errorSchedules"></div>
              {{$t("views.channels.immediate")}}
            </div>
            <div
              class="tab"
              :class="{ active: selectedPlanned }"
              @click="selectedPlanned = true"
            >
              <div class="error-circle" v-if="errorPlannedSchedules"></div>
              {{$t("views.channels.planned")}}
            </div>
          </div>
          <div class="services-box">
            <template v-if="selectedPlanned && plannedSchedules.length === 0">
              <div class="no-planned">
                {{$t("views.channels.no_changes")}}
              </div>
              <div class="planner" @click="initPlanned()">
                {{$t("views.channels.plan_change")}}
              </div>
            </template>

            <template v-else-if="selectedPlanned">
              <!-- Multiple Planned Schedules Navigation (always shown) -->
              <div class="planned-schedules-nav">
                <div class="nav-title">Cambios Programados:</div>
                <div class="nav-buttons">
                  <div 
                    v-for="(schedule, index) in plannedSchedules" 
                    :key="index"
                    class="nav-button"
                    :class="{ active: selectedPlannedIndex === index }"
                    @click="selectPlannedSchedule(index)"
                  >
                    {{ $t("views.channels.planned") }} {{ index + 1 }}
                    <span class="date">({{ schedule.plan_date }})</span>
                    <v-icon 
                      class="remove-icon" 
                      @click.stop="removePlannedSchedule(index)"
                      small
                    >
                      close
                    </v-icon>
                  </div>
                </div>
                <div class="nav-actions">
                  <div 
                    v-if="plannedSchedules.length < 2"
                    class="bttn add"
                    @click="addNewPlannedSchedule()"
                  >
                    <v-icon color="#fff">add</v-icon>
                    Agregar cambio programado
                  </div>
                  <div 
                    v-if="plannedSchedules.length > 0"
                    class="bttn delete" 
                    @click="removePlannedSchedule(selectedPlannedIndex)"
                  >
                    <v-icon color="#fff">delete</v-icon>
                    {{$t("views.channels.discard_planned_change")}}
                  </div>
                </div>
              </div>

              <!-- Planned Content (shown when there are planned schedules) -->
              <div v-if="plannedSchedules.length > 0" class="part services">
                <div class="alert" :class="{ show: changesDetected.planDate }">
                  {{$t("views.channels.schedule_pending_changes")}}
                </div>
                <div class="plan-date">
                  <div class="label">
                    {{$t("views.channels.question.day")}}
                  </div>
                  <input
                    type="date"
                    v-model="plannedSchedules[selectedPlannedIndex].plan_date"
                    @change="changesDetected.planDate = true"
                    :min="tomorrowDate()"
                  />
                </div>

                <span class="title subarea"
                  >{{$t("views.channels.services")}}</span
                >

                <div
                  class="alert"
                  :class="{ show: changesDetected.plannedService }"
                >
                  {{$t("views.channels.schedule_pending_changes")}}
                </div>

                <template v-for="item in orderServices()">
                  <div
                    class="item"
                    :key="item.id"
                    @click="selectService(item, 'planned')"
                  >
                    <img
                      v-if="
                        currentPlannedServices.length > 0 ||
                          currentPlannedServices[item.id] != undefined
                      "
                      :class="{
                        disabled: !currentPlannedServices.includes(item.id)
                      }"
                      :src="item.img"
                    />
                    <img
                      v-else
                      :class="{
                        disabled: !currentPlannedServices.includes(item.id)
                      }"
                      :src="item.img"
                    />
                    <!-- Delete this v-if condition -->
                    <span class="name">{{ item.name }}</span>
                  </div>
                </template>
                <template v-if="false">
                  <span class="title subarea"
                    >{{$t("views.channels.my_order")}}</span
                  >

                  <!-- <span class="title-decription"
                    >Los iconos a continuación activarán cada uno de esos
                    servicios en MyOrder, asegúrate que tu restaurante tiene
                    todo preparado para tener cada uno de ellos activos.
                    Recuerda seleccionar los servicios de MyOrder disponibles en
                    tu restaurante, en caso contrario los clientes no podrán
                    verlos en la App</span
                  > -->
                  <span class="title-decription">
                    <span>
                      {{ $t("views.channels.description.my_order_before") }}<strong>{{ $t("views.channels.description.my_order_bold") }}</strong>{{ $t("views.channels.description.my_order_after") }}
                    </span>
                  </span>

                  <!-- <div
                    class="alert"
                    v-if="myOrderShowAlert"
                    :class="{ show: myOrderShowAlert }"
                  >
                    Recuerda seleccionar los servicios de MyOrder disponibles en
                    el restaurante
                  </div> -->
                  <template v-for="item in myOrderServices()">
                    <div
                      class="item"
                      :key="item.id"
                      @click="selectService(item, 'planned')"
                    >
                      <img
                        v-if="
                          currentPlannedServices.length > 0 ||
                            currentPlannedServices[item.id] != undefined
                        "
                        :class="{
                          disabled: !currentPlannedServices.includes(item.id)
                        }"
                        :src="item.img"
                      />
                      <img
                        v-else
                        :class="{
                          disabled: !currentPlannedServices.includes(item.id)
                        }"
                        :src="item.img"
                      />
                      <!-- Delete this v-if condition -->
                      <span class="name">{{ item.name }}</span>
                    </div>
                  </template>
                </template>
              </div>
              <div class="part schedule">
                <span class="title subarea">{{$t("views.channels.schedule.restaurant")}}</span>
                <div
                  class="alert"
                  :class="{ show: changesDetected.restaurant }"
                >
                  {{$t("views.channels.schedule_pending_changes")}}
                </div>
                <div class="align-center" v-if="currentPlannedScheduleData.restaurant">
                  <div
                    class="turn"
                    v-for="(suboption, subindex) in currentPlannedScheduleData.restaurant"
                  >
                    <div v-if="subindex == 'monday'" class="name">
                      {{$t("days.monday")}}
                    </div>
                    <div v-else-if="subindex == 'tuesday'" class="name">
                      {{$t("days.tuesday")}}
                    </div>
                    <div v-else-if="subindex == 'wednesday'" class="name">
                      {{$t("days.wednesday")}}
                    </div>
                    <div v-else-if="subindex == 'thursday'" class="name">
                      {{$t("days.thursday")}}
                    </div>
                    <div v-else-if="subindex == 'friday'" class="name">
                      {{$t("days.friday")}}
                    </div>
                    <div v-else-if="subindex == 'saturday'" class="name">
                      {{$t("days.saturday")}}
                    </div>
                    <div v-else-if="subindex == 'sunday'" class="name">
                      {{$t("days.sunday")}}
                    </div>
                    <div v-else-if="subindex == 'festive'" class="name">
                      {{$t("days.festive")}}
                    </div>

                    <div class="time">
                      <vue-timepicker
                        input-width="100px"
                        class="start-date date"
                        :minute-interval="15"
                        format="HH:mm"
                        v-model="plannedSchedules[selectedPlannedIndex].schedules.restaurant[subindex].start"
                        :class="{
                          error: inputErrorCheck(
                            currentPlannedScheduleData.restaurant[subindex].start,
                            'restaurant',
                            'planned'
                          )
                        }"
                      ></vue-timepicker>
                      <span>-</span>
                      <vue-timepicker
                        input-width="100px"
                        class="start-date date"
                        :minute-interval="15"
                        format="HH:mm"
                        v-model="plannedSchedules[selectedPlannedIndex].schedules.restaurant[subindex].end"
                        :class="{
                          error: inputErrorCheck(
                            currentPlannedScheduleData.restaurant[subindex].end,
                            'restaurant',
                            'planned'
                          )
                        }"
                      ></vue-timepicker>
                    </div>
                    <v-switch
                      class="switch"
                      :input-value="
                        currentPlannedScheduleData.restaurant[subindex].start ==
                          '00:00' &&
                          currentPlannedScheduleData.restaurant[subindex].end == '00:00'
                      "
                      @click="
                        allDayChangeSchedule(
                          currentPlannedScheduleData.restaurant[subindex]
                        )
                      "
                      inset
                      :label="'24h'"
                    ></v-switch>
                  </div>
                </div>
              </div>
              <div v-if="currentPlannedServices.length > 0">
                <template
                  v-for="(option, index) in currentPlannedScheduleData"
                  v-if="index != 'restaurant'"
                >
                  <div
                    class="part schedule"
                    v-if="
                      index == 'delivery' && [service[index].id] &&
                        currentPlannedServices.includes(
                          [service[index].id][0]
                        )
                    "
                  >
                    <span class="title subarea">Delivery</span>
                    <v-text-field
                      :label="$t('views.channels.example')"
                      v-model="plannedSchedules[selectedPlannedIndex].schedules.delivery"
                    ></v-text-field>
                  </div>
                  <div
                    class="part schedule"
                    v-else-if="
                      [service[index].id] &&
                        currentPlannedServices.includes(
                          [service[index].id][0]
                        )
                    "
                  >
                    <span v-if="index == 'mcauto'" class="title subarea"
                      >{{$t("views.channels.schedule.delivery")}}</span
                    >
                    <span v-else-if="index == 'mcexpress'" class="title subarea"
                      >{{$t("views.channels.schedule.express")}}</span
                    >
                    <span v-else-if="index == 'takeaway'" class="title subarea"
                      >{{$t("views.channels.schedule.takeaway")}}</span
                    >

                    <div
                      class="alert"
                      :class="{ show: changesDetected[index] }"
                    >
                      {{$t("views.channels.schedule_pending_changes")}}
                    </div>

                    <div class="align-center">
                      <div
                        class="turn"
                        v-for="(suboption, subindex) in currentPlannedScheduleData[index]"
                      >
                        <div v-if="subindex == 'monday'" class="name">
                          {{$t("days.monday")}}
                        </div>
                        <div v-else-if="subindex == 'tuesday'" class="name">
                          {{$t("days.tuesday")}}
                        </div>
                        <div v-else-if="subindex == 'wednesday'" class="name">
                          {{$t("days.wednesday")}}
                        </div>
                        <div v-else-if="subindex == 'thursday'" class="name">
                          {{$t("days.thursday")}}
                        </div>
                        <div v-else-if="subindex == 'friday'" class="name">
                          {{$t("days.friday")}}
                        </div>
                        <div v-else-if="subindex == 'saturday'" class="name">
                          {{$t("days.saturday")}}
                        </div>
                        <div v-else-if="subindex == 'sunday'" class="name">
                          {{$t("days.sunday")}}
                        </div>
                        <div v-else-if="subindex == 'festive'" class="name">
                          {{$t("days.festive")}}
                        </div>

                        <div class="time">
                          <vue-timepicker
                            :key="index + subindex + 'plan-start'"
                            input-width="100px"
                            class="start-date date"
                            :minute-interval="15"
                            format="HH:mm"
                            v-model="plannedSchedules[selectedPlannedIndex].schedules[index][subindex].start"
                            :class="{
                              error: inputErrorCheck(
                                currentPlannedScheduleData[index][subindex].start,
                                index,
                                'planned'
                              )
                            }"
                          ></vue-timepicker>
                          <span>-</span>
                          <vue-timepicker
                            :key="index + subindex + 'plan-end'"
                            input-width="100px"
                            class="start-date date"
                            :minute-interval="15"
                            format="HH:mm"
                            v-model="plannedSchedules[selectedPlannedIndex].schedules[index][subindex].end"
                            :class="{
                              error: inputErrorCheck(
                                currentPlannedScheduleData[index][subindex].end,
                                index,
                                'planned'
                              )
                            }"
                          ></vue-timepicker>
                        </div>
                        <v-switch
                          class="switch"
                          :input-value="
                            currentPlannedScheduleData[index][subindex].start ==
                              '00:00' &&
                              currentPlannedScheduleData[index][subindex].end == '00:00'
                          "
                          @click="
                            allDayChangeSchedule(
                              currentPlannedScheduleData[index][subindex]
                            )
                          "
                          inset
                          :label="'24h'"
                        ></v-switch>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- <div class="part full-day">
                <span class="title subarea">24 horas</span> -->

              <!-- <div class="options">
                  <v-container grid-list-xl>
                    <div
                      class="alert"
                      :class="{ show: changesDetected.plannedAllday }"
                    >
                      Cambios pendientes de confirmar
                    </div>
                    <v-radio-group
                      key="planned-fullday"
                      v-model="plannedAllday"
                      @change="
                        alldayAction('planned');
                        changesDetected.plannedAllday = true;
                      "
                    >
                      <v-layout wrap>
                        <v-flex>
                          <v-radio
                            label="Todos los dias"
                            value="all"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-radio
                            label="Viernes y Sábado"
                            value="weekend"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-radio
                            label="Viernes, Sábado y Vísperas"
                            value="vespers"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-text-field
                            key="planned-fullday-custom"
                            label="Otros"
                            v-model="plannedTextAllDay"
                            @input="
                              plannedAllday = $event;
                              changesDetected.plannedAllday = true;
                            "
                            color="#004412"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-container>
                </div>
              </div> -->
            </template>

            <template v-else-if="!selectedPlanned">
              <div class="part services" v-if="true">
                <template>
                  <span class="title subarea"
                    >{{$t("views.channels.services")}}</span
                  >

                  <div class="alert" :class="{ show: changesDetected.service }">
                    {{$t("views.channels.schedule_pending_changes")}}
                  </div>

                  <template v-for="item in orderServices()">
                    <div
                      class="item"
                      :key="item.id"
                      @click="selectService(item, 'immediate')"
                    >
                      <img
                        v-if="
                          restaurantService.length > 0 ||
                            restaurantService[item.id] != undefined
                        "
                        :class="{
                          disabled: restaurantService[item.id].status != 1
                        }"
                        :src="item.img"
                      />
                      <img
                        v-else
                        :class="{ disabled: restaurantService[item.id] != 1 }"
                        :src="item.img"
                      />
                      <!-- Delete this v-if condition -->
                      <span class="name">{{ item.name }}</span>
                    </div>
                  </template>
                </template>
                <template>
                  <span class="title subarea">{{$t("views.channels.my_order")}}</span>

                  <span class="title-decription">
                    <span>
                      {{ $t("views.channels.description.my_order_before") }}<strong>{{ $t("views.channels.description.my_order_bold") }}</strong>{{ $t("views.channels.description.my_order_after") }}
                    </span>
                  </span>

                  <div class="mop-status">
                    {{$t("general.status")}}: 

                    <template v-if="mopService && mopService.status == 1">
                      <span class="value s1">{{$t("general.active")}}</span>
                      <span
                        class="action"
                        @click="onPypToggle()"
                        >{{$t("general.activate")}}</span
                      >
                    </template>
                    <template v-else>
                      <span class="value s2">{{$t("general.inactive")}}</span>
                      <span
                        class="action"
                        @click="onPypToggle()"
                        >{{$t("general.activate")}}</span
                      >
                    </template>
                  </div>

                  <div class="alert" :class="{ show: changesDetected.myorder }">
                    {{$t("views.channels.schedule_pending_changes")}}
                  </div>

                  <template v-if="mopService && mopService.status == 1">
                    <div class="title">{{ $t("views.channels.disable.my_order")}} </div>
                    <span class="title-decription"
                      >{{$t("views.channels.description.my_order_programmed")}}</span
                    >

                    <div id="mop-schedule">
                      <div
                        class="mop-item"
                        v-for="(option, index) in mopSchedule"
                      >
                        <div class="content">
                          <div class="header">
                            <span :class="['status', 's' + option.status]">{{
                              status[option.status]
                            }}</span>
                            <span class="log date"
                              >{{$t("views.channels.solicited")}}: {{ option.log_date }}</span
                            >
                            <div v-if="option.cancel" class="log date">
                              {{$t("views.channels.cancelation")}}: <b>{{ option.cancel }}</b>
                            </div>
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.from")}}</span>
                            <input
                              class="start date"
                              type="datetime-local"
                              v-model="option.start_date"
                              disabled
                            />
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.to")}}</span>
                            <input
                              class="end date"
                              type="datetime-local"
                              v-model="option.end_date"
                              disabled
                            />
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.reason")}}</span>
                            <span class="value" disabled>{{
                              option.value
                            }}</span>
                            <!--<input
                              class="value"
                              type="text"
                              v-model="option.value"
                              disabled
                            />-->
                          </div>
                        </div>
                        <!--<div class="actions">
                          <span
                            class="icon"
                            @click="removeMopSchedule(option.id)"
                            >Eliminar</span
                          >
                        </div>-->
                      </div>
                      <div
                        class="mop-item"
                        v-for="(option, index) in mopNewSchedule"
                      >
                        <div class="content">
                          <div class="header">
                            <span :class="['status', 's0']"
                              >{{$t("views.channels.schedule_pending_changes")}}</span
                            >
                            <div class="actions">
                              <span
                                class="icon"
                                @click="removeMopSchedule(index)"
                                >Eliminar</span
                              >
                            </div>
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.from")}}</span>
                            <input
                              class="start date"
                              type="datetime-local"
                              v-model="option.start_date"
                              disabled
                            />
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.to")}}</span>
                            <input
                              class="end date"
                              type="datetime-local"
                              v-model="option.end_date"
                              disabled
                            />
                          </div>

                          <div class="col">
                            <span class="label">{{$t("general.reason")}}</span>
                            <span class="value" disabled>{{
                              option.value
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="mop-item new" @click="showMopSchedule()">
                        {{$t("views.channels.new")}}
                      </div>

                      <MopPopup
                        v-if="bShowMopPopup"
                        @cancel="cancelMopSchedule()"
                        @add="addMopSchedule"
                      ></MopPopup>
                    </div>
                  </template>
                </template>
              </div>
              <div class="title">{{ $t("views.channels.schedules") }}</div>
              <div class="part schedule">
                <span class="title subarea">{{ $t("views.channels.schedule.restaurant") }}</span>
                <div
                  class="alert"
                  :class="{ show: changesDetected.restaurant }"
                >
                  {{$t("views.channels.schedule_pending_changes")}}
                </div>
                <div class="align-center" v-if="schedules.restaurant">
                  <div
                    class="turn"
                    v-for="(suboption, subindex) in schedules.restaurant"
                  >
                    <div v-if="subindex == 'monday'" class="name">
                      {{$t("days.monday")}}
                    </div>
                    <div v-else-if="subindex == 'tuesday'" class="name">
                      {{$t("days.tuesday")}}
                    </div>
                    <div v-else-if="subindex == 'wednesday'" class="name">
                      {{$t("days.wednesday")}}
                    </div>
                    <div v-else-if="subindex == 'thursday'" class="name">
                      {{$t("days.thursday")}}
                    </div>
                    <div v-else-if="subindex == 'friday'" class="name">
                      {{$t("days.friday")}}
                    </div>
                    <div v-else-if="subindex == 'saturday'" class="name">
                      {{$t("days.saturday")}}
                    </div>
                    <div v-else-if="subindex == 'sunday'" class="name">
                      {{$t("days.sunday")}}
                    </div>
                    <div v-else-if="subindex == 'festive'" class="name">
                      {{$t("days.festive")}}
                    </div>

                    <div class="time">
                      <vue-timepicker
                        input-width="100px"
                        class="start-date date"
                        :minute-interval="15"
                        format="HH:mm"
                        v-model="schedules.restaurant[subindex].start"
                        :class="{
                          error: inputErrorCheck(
                            schedules.restaurant[subindex].start,
                            'restaurant',
                            'immediate'
                          )
                        }"
                      ></vue-timepicker>
                      <span>-</span>
                      <vue-timepicker
                        input-width="100px"
                        class="start-date date"
                        :minute-interval="15"
                        format="HH:mm"
                        v-model="schedules.restaurant[subindex].end"
                        :class="{
                          error: inputErrorCheck(
                            schedules.restaurant[subindex].end,
                            'restaurant',
                            'immediate'
                          )
                        }"
                      ></vue-timepicker>
                    </div>
                    <v-switch
                      class="switch"
                      :input-value="
                        schedules.restaurant[subindex].start == '00:00' &&
                          schedules.restaurant[subindex].end == '00:00'
                      "
                      @click="
                        allDayChangeSchedule(schedules.restaurant[subindex])
                      "
                      inset
                      :label="'24h'"
                    ></v-switch>
                  </div>
                </div>
              </div>

              <div v-if="Object.keys(restaurantService).length > 0">
                <template
                  v-for="(option, index) in schedules"
                  v-if="index != 'restaurant'"
                >
                  <div
                    class="part schedule"
                    v-if="
                      index == 'delivery' &&
                        restaurantService[service[index].id] != undefined &&
                        restaurantService[service[index].id].status == 1
                    "
                  >
                    <span class="title subarea">Delivery</span>
                    <v-text-field
                      label="Ej.Abierto de XXh a XXh"
                      v-model="schedules.delivery"
                    ></v-text-field>
                  </div>

                  <div
                    class="part schedule"
                    v-else-if="
                      restaurantService[service[index].id] != undefined &&
                        restaurantService[service[index].id].status == 1
                    "
                  >
                    <span v-if="index == 'mcauto'" class="title subarea"
                      >{{ $t("views.channels.schedule.delivery") }}</span
                    >
                    <span v-else-if="index == 'mcexpress'" class="title subarea"
                      >{{ $t("views.channels.schedule.mcexpress") }}</span
                    >
                    <span v-else-if="index == 'takeaway'" class="title subarea"
                      >{{ $t("views.channels.schedule.takeaway") }}</span
                    >

                    <div
                      class="alert"
                      :class="{ show: changesDetected[index] }"
                    >
                      {{$t("views.channels.schedule_pending_changes")}}
                    </div>

                    <div class="align-center">
                      <div
                        class="turn"
                        v-for="(suboption, subindex) in schedules[index]"
                      >
                        <div v-if="subindex == 'monday'" class="name">
                          {{$t("days.monday")}}
                        </div>
                        <div v-else-if="subindex == 'tuesday'" class="name">
                          {{$t("days.tuesday")}}
                        </div>
                        <div v-else-if="subindex == 'wednesday'" class="name">
                          {{$t("days.wednesday")}}
                        </div>
                        <div v-else-if="subindex == 'thursday'" class="name">
                          {{$t("days.thursday")}}
                        </div>
                        <div v-else-if="subindex == 'friday'" class="name">
                          {{$t("days.friday")}}
                        </div>
                        <div v-else-if="subindex == 'saturday'" class="name">
                          {{$t("days.saturday")}}
                        </div>
                        <div v-else-if="subindex == 'sunday'" class="name">
                          {{$t("days.sunday")}}
                        </div>
                        <div v-else-if="subindex == 'festive'" class="name">
                          {{$t("days.festive")}}
                        </div>

                        <div class="time">
                          <vue-timepicker
                            :key="index + subindex + 'immediate-start'"
                            input-width="100px"
                            class="start-date date"
                            :minute-interval="15"
                            format="HH:mm"
                            v-model="schedules[index][subindex].start"
                            :class="{
                              error: inputErrorCheck(
                                schedules[index][subindex].start,
                                index,
                                'immediate'
                              )
                            }"
                          ></vue-timepicker>
                          <span>-</span>
                          <vue-timepicker
                            :key="index + subindex + 'immediate-end'"
                            input-width="100px"
                            class="start-date date"
                            :minute-interval="15"
                            format="HH:mm"
                            v-model="schedules[index][subindex].end"
                            :class="{
                              error: inputErrorCheck(
                                schedules[index][subindex].end,
                                index,
                                'immediate'
                              )
                            }"
                          ></vue-timepicker>
                        </div>
                        <v-switch
                          class="switch"
                          :input-value="
                            schedules[index][subindex].start == '00:00' &&
                              schedules[index][subindex].end == '00:00'
                          "
                          @click="
                            allDayChangeSchedule(schedules[index][subindex])
                          "
                          inset
                          :label="'24h'"
                        ></v-switch>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- <div class="part full-day">
                <span class="title subarea">24 horas</span>

                <div class="options">
                  <v-container grid-list-xl>
                    <div
                      class="alert"
                      :class="{ show: changesDetected.allday }"
                    >
                      Cambios pendientes de confirmar
                    </div>
                    <v-radio-group
                      key="inmediate-fullday"
                      v-model="allday"
                      @change="
                        alldayAction('immediate');
                        changesDetected.allday = true;
                      "
                    >
                      <v-layout wrap>
                        <v-flex>
                          <v-radio
                            label="Todos los dias"
                            value="all"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-radio
                            label="Viernes y Sábado"
                            value="weekend"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-radio
                            label="Viernes, Sábado y Vísperas"
                            value="vespers"
                            color="#004412"
                          ></v-radio>
                        </v-flex>

                        <v-flex md3>
                          <v-text-field
                            key="inmediate-fullday-custom"
                            label="Otros"
                            v-model="textAllDay"
                            @input="
                              allday = $event;
                              changesDetected.allday = true;
                            "
                            color="#004412"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-container>
                </div>
              </div> -->
            </template>
          </div>

          <!-- <div
              class="part schedule"
              v-if="restaurantService[service['mcauto'].id]!=undefined && restaurantService[service['mcauto'].id].status == 1"
            >
              <span class="title subarea">Horario McAuto</span>
              <div class="align-center">
                <div class="turn">
                  <div class="name">Lunes a Jueves</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.week.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.week.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Viernes y Sábado</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.weekend.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.weekend.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Domingo</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.sunday.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.sunday.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Vísperas / Festivos</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.party.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcauto.party.end"
                    ></vue-timepicker>
                  </div>
                </div>
              </div>
            </div> -->

          <!-- <div class="part schedule" v-if="restaurantService[service['delivery'].id]!=undefined && restaurantService[service['delivery'].id].status == 1">
              <span class="title subarea">Horario Delivery</span>
              <div class="align-center">
                <div class="turn">
                  <div class="name">Lunes a Jueves</div>
                  <div class="time">
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.week.start"></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.week.end"></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Viernes y Sábado</div>
                  <div class="time">
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.weekend.start"></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.weekend.end"></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Domingo</div>
                  <div class="time">
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.sunday.start"></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.sunday.end"></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Vísperas / Festivos</div>
                  <div class="time">
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.party.start"></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker input-width="100px" class="start-date date" :minute-interval="15" format="HH:mm" v-model="schedules.delivery.party.end"></vue-timepicker>
                  </div>
                </div>
              </div>
            </div> -->

          <!-- <div
              class="part schedule"
              v-if="restaurantService[service['mcexpress'].id]!=undefined && restaurantService[service['mcexpress'].id].status == 1"
            >
              <span class="title subarea">Horario McExpress</span>
              <div class="align-center">
                <div class="turn">
                  <div class="name">Lunes a Jueves</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.week.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.week.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Viernes y Sábado</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.weekend.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.weekend.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Domingo</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.sunday.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.sunday.end"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="turn">
                  <div class="name">Vísperas / Festivos</div>
                  <div class="time">
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.party.start"
                    ></vue-timepicker>
                    <span>-</span>
                    <vue-timepicker
                      input-width="100px"
                      class="start-date date"
                      :minute-interval="15"
                      format="HH:mm"
                      v-model="schedules.mcexpress.party.end"
                    ></vue-timepicker>
                  </div>
                </div>
              </div>
            </div> -->

          <!-- <template v-for="service in restaurantService"> -->
          <!-- <div
              class="part birthday"
              v-if="
                (service.slug == 'birthday_home' ||
                  service.slug == 'birthday') &&
                  (service.status == 1 ||
                    currentPlannedServices.includes(service.id))
              "
            > -->
          <div class="part birthday" v-if="checkBirthdayActive">
            <span class="title subarea">{{ $t("views.channels.birthday") }}</span>

            <div class="birth-check">
              <div class="birth-check-item">
                <v-checkbox
                  v-model="birthdayData.book_online"
                  color="#000"
                  class="checkbox"
                  :label="$t('views.channels.book_online')"
                  @change="birthdayData = { ...birthdayData }"
                ></v-checkbox>
              </div>
            </div>
            <template v-if="birthdayData && birthdayData.book_online">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <!-- <template v-for="service in restaurantService">
                  <v-flex
                    md4
                    v-if="
                      (service.slug == 'birthday_home' ||
                        service.slug == 'birthday') &&
                        (service.status == 1 ||
                          currentPlannedServices.includes(service.id))
                    "
                    :key="service.id"
                  >
                    <v-switch
                      class="switch"
                      v-model="birthdayData[service.slug + '_type']"
                      inset
                    >
                      <template #prepend>
                        <v-label color="#000"
                          >Cumpleaños
                          {{
                            service.slug == "birthday_home" ? "en casa" : ""
                          }}:‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎</v-label
                        >
                        <v-label>Básico</v-label>
                      </template>
                      <template #append>
                        <v-label>Premium</v-label>
                      </template>
                    </v-switch>
                  </v-flex>
                </template>

                <div class="clear" style="width: 100%"></div> -->

                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.bank_account')"
                      v-model="birthdayData.bank_account"
                      :hint="$t('views.channels.description.bank_account')"
                      persistent-hint
                      :class="{
                        error:
                          validateBirthdayData('bank_account') && checkBirthday
                      }"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.bizum')"
                      v-model="birthdayData.bizum"
                      :hint="$t('views.channels.description.bizum')"
                      persistent-hint
                      :class="{
                        error: validateBirthdayData('bizum') && checkBirthday
                      }"
                    ></v-text-field>
                  </v-flex>

                  <div class="clear" style="width: 100%"></div>

                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.contact_phone')"
                      v-model="birthdayData.contact_phone"
                      :hint="$t('views.channels.description.contact_phone')"
                      persistent-hint
                      :class="{
                        error:
                          validateBirthdayData('contact_phone') && checkBirthday
                      }"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.contact_mail')"
                      v-model="birthdayData.contact_mail"
                      :class="{
                        error:
                          validateBirthdayData('contact_mail') && checkBirthday
                      }"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <div class="clear" style="width: 100%"></div>

                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.name')"
                      v-model="razon"
                      :class="{
                        error: validateBirthdayData('razon') && checkBirthday
                      }"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.cif')"
                      v-model="CIF"
                      :class="{
                        error: validateBirthdayData('CIF') && checkBirthday
                      }"
                      hide-details
                    ></v-text-field>
                  </v-flex>

                  <v-flex md4>
                    <v-text-field
                      :label="$t('views.channels.fiscal_address')"
                      v-model="fiscal_address"
                      :class="{
                        error:
                          validateBirthdayData('fiscal_address') &&
                          checkBirthday
                      }"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </div>
          <!-- </template> -->

          <div
            v-show="updated != false"
            class="message success fadeIn"
            style="text-align: center;"
          >
            {{ $t("views.channels.saved_changes") }}
          </div>
          <div class="save" @click="updateInfo()">{{ $t("views.channels.update_changes") }}</div>
        </div>
      </div>

      <div class="reports section" ref="reports">
        <span class="title"
          >{{ $t("views.channels.generated_forms") }}
          <div class="g-business"></div
        ></span>
        <span class="sec-description"
          >{{ $t("views.channels.check_forms") }}</span
        >
        <div class="reports-box">
          <template v-if="reports.length > 0">
            <div v-for="(report, id ) in reports" :key="report.id" class="report">
              <div class="report-topbar">
                <div class="meta" @click="selectReport(report.id)">
                <div class="pdf" @click="preview(report.url)"></div>
                {{ $t("views.channels.form_of") }}
                {{ report.month_formatted }}
              </div>
              <div class="actions">
                <div class="action" @click="preview(report.url)">
                  {{ $t("general.download") }}
                </div>
                <!-- <a download :href="s3Url + report.report_filename"
                  >Descargar</a
                > -->
                <!-- <div class="action">Descargar</div> -->
              </div>
              
              </div>
              <iframe :class="{'active': currentReport == report.id}" class="report-viewer" :src="report.url" width="100%" height="100%"></iframe>
            </div>
          </template>
          <template v-else>
            <div class="empty">
              {{ $t("views.channels.empty_reports") }}
            </div>
          </template>
        </div>
      </div>

      <div class="offers section" ref="offers">
        <span class="title">{{ $t('views.channels.local_offers') }}</span>
        <span class="sec-description"
          >{{ $t("views.channels.description.local_offers") }}</span
        >
        <a
          target="_blank"
          href="https://marketengine.app/es/home"
          class="prices"
          >{{ $t("login.access") }}</a
        >
        <div class="preview-pdf paginated">
          <div class="pdf-pages hide-scrollbar">
            <iframe
              :src="pdfofertas"
              width="100%"
              height="600px"
              style="margin: 20px auto;"
            ></iframe>
          </div>
        </div>
      </div>

      <div class="rrss section" ref="rrss">
        <span class="title">{{ $t("views.channels.rrss") }}</span>
        <span class="sec-description"
          >{{ $t("views.channels.description.rrss") }}</span
        >
        <div class="preview-pdf paginated">
          <div class="pdf-pages hide-scrollbar">
            <embed
              :src="pdfrrss"
              type="application/pdf"
              height="600px"
              width="100%"
              style="margin:20px auto;"
            >
              <template slot="loading"
                >{{ $t("views.channels.loading") }}</template
              >
            </embed>
          </div>
        </div>

        <div class="button submit" @click="downloadRRSS()">
          {{ $t('general.download') }}
        </div>
      </div>

      <div ref="paid" class="paid">
        <div class="title area">{{ $t("views.channels.paid") }}</div>

        <!--<div class="photo"></div>
        <div class="download">Haz click aquí para descargar más información</div>-->

        <div class="briefing section" ref="briefing">
          <span class="title">{{ $t("views.channels.paid_campaign") }}</span>
          <span class="sec-description"
            >{{ $t("views.channels.description.paid_campaign") }}</span
          >

          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex md12 align-center>
                <v-select
                  :items="[
                    $t('views.channels.items.consulting'),
                    $t('views.channels.items.directional'),
                    $t('views.channels.items.tactical')
                  ]"
                  v-model="briefingData.type"
                  :label="$t('views.channels.petition_type')"
                ></v-select>
                <div
                  v-if="briefingData.type == $t('views.channels.items.consulting')"
                  class="description"
                >
                  {{ $t("views.channels.item_description.consulting") }}
                </div>
                <div
                  v-if="briefingData.type == $t('views.channels.items.directional')"
                  class="description"
                >
                  {{ $t("views.channels.item_description.directional") }}
                </div>
                <div
                  v-if="briefingData.type == $t('views.channels.items.tactical')"
                  class="description"
                >
                  {{ $t("views.channels.item_description.tactical") }}
                </div>
              </v-flex>

              <v-flex md6>
                <v-textarea
                  auto-grow
                  rows="1"
                  v-model="briefingData.business"
                  :label="$t('views.channels.negotiation')"
                ></v-textarea>
                <div class="description">
                  {{ $t("views.channels.description.negotiation") }}
                </div>
              </v-flex>

              <v-flex md6>
                <v-textarea
                  auto-grow
                  rows="1"
                  v-model="briefingData.marketing"
                  :label="$t('views.channels.marketing')"
                ></v-textarea>
                <div class="description">
                  {{ $t("views.channels.description.marketing") }}
                </div>
              </v-flex>

              <v-flex md6>
                <v-textarea
                  auto-grow
                  rows="1"
                  v-model="briefingData.target"
                  :label="$t('views.channels.target')"
                ></v-textarea>
                <div class="description">
                  {{ $t("views.channels.description.target") }}
                </div>
              </v-flex>

              <v-flex md6 align-center>
                <v-text-field
                  v-model="briefingData.date"
                  :label="$t('views.channels.date')"
                ></v-text-field>
                <div
                  v-if="
                    briefingData.type == 'Consultoría estratégica' ||
                      briefingData.type == 'Direccionales y Exterior'
                  "
                  class="description"
                >
                  {{ $t("views.channels.description.delivery_date") }}
                </div>
                <div
                  v-if="briefingData.type == 'Activaciones tácticas'"
                  class="description"
                >
                  {{ $t("views.channels.description.estimated_date") }}
                </div>
              </v-flex>

              <v-flex md6 align-center>
                <v-text-field
                  v-if="briefingData.type == 'Activaciones tácticas'"
                  v-model="briefingData.budget"
                  type="number"
                  :label="$t('views.channels.description.budget') + '<br>' + $t('views.channels.description.depending_budget')"
                  append-icon="euro"
                ></v-text-field>
                <div
                  v-if="briefingData.type == 'Activaciones tácticas'"
                  class="description"
                  v-html="$t('views.channels.description.budget') + '<br>' + $t('views.channels.description.depending_budget')"
                >
                </div>
              </v-flex>

              <v-flex md6> </v-flex>

              <div class="button submit" @click="updateBriefing()">{{ $t("general.send") }}</div>
            </v-layout>
          </v-container>
        </div>

        <div class="preview-pdf paginated">

          <div class="pdf-pages hide-scrollbar">
            <embed
              :src="pdfpaid"
              type="application/pdf"
              height="600px"
              width="100%"
              style="margin:20px auto;"
            >
              <template slot="loading"
                >{{ $t("views.channels.loading") }}</template
              >
            </embed>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import VueTimepicker from "vue2-timepicker";
import MopPopup from "@/components/domain/admin/MopPopup";
import "vue2-timepicker/dist/VueTimepicker.css";

import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "Channels",
  components: { VueTimepicker, MopPopup },

  data() {
    return {
      bShowMopPopup: false,
      myOrderShowAlert: false,
      pypBlocked: false,
      menuHide: false,
      scrolling: false,
      scrollWait: false,
      updated: false,
      change: false,
      load: true,
      changesDetected: {},
      checkBirthday: false,
      startSchedule: {},
      schedulesServicesCount: {},
      errorSchedules: false,
      errorPlannedSchedules: false,
      errorBirthday: {},
      errorTemp_opening: false,
      errorTemp_opening_motive: false,
      selectedPlanned: false,
      changePlanned: false,
      selectedPlannedIndex: 0, // Track which planned schedule is selected

      pdfpaid:
        process.env.VUE_APP_API_URL + "static/pdf/omd.pdf?" +
        moment(new Date()).format("DD/MM/YYYY"),
      /* pdfrrss:
        "https://lsm.mcdonalds.es/api/static/pdf/rrss.pdf?" +
        moment(new Date()).format("DD/MM/YYYY"), */
      pdfrrss: process.env.VUE_APP_API_URL + "static/pdf/rrss.pdf",
      pdfofertas: process.env.VUE_APP_API_URL + "static/pdf/ofertas.pdf",
      pagepaid: 1,
      pagerrss: 1,
      numPagespaid: 0,
      numPagesrrss: 0,
      errors: [],
      // scale: 'page-width',
      scale: 0.7,

      textAllDay: "",

      /* FORM VARIABLES */
      name: "",
      razon: "",
      CIF: "",
      fiscal_address: "",
      address: "",
      phone: "",
      log_date: "",
      email: "",
      type: "",
      region: "",
      cv_public: "",
      cv_team: "",
      restaurantService: {},
      birthdayData: {},
      schedules: {},
      allday: "",
      temp_opening: "1",
      temp_opening_date: false,
      temp_opening_motive: null,
      // Change to array to support multiple planned schedules
      plannedSchedules: [], // Array of planned schedule objects
      mopSchedule: {},
      mopNewSchedule: [],
      currentReport: null,

      schedulesEmptyTemplate: {
        restaurant: {
          monday: {
            start: "",
            end: ""
          },
          tuesday: {
            start: "",
            end: ""
          },
          wednesday: {
            start: "",
            end: ""
          },
          thursday: {
            start: "",
            end: ""
          },
          friday: {
            start: "",
            end: ""
          },
          saturday: {
            start: "",
            end: ""
          },
          sunday: {
            start: "",
            end: ""
          },
          festive: {
            start: "",
            end: ""
          }
        },
        mcauto: {
          monday: {
            start: "",
            end: ""
          },
          tuesday: {
            start: "",
            end: ""
          },
          wednesday: {
            start: "",
            end: ""
          },
          thursday: {
            start: "",
            end: ""
          },
          friday: {
            start: "",
            end: ""
          },
          saturday: {
            start: "",
            end: ""
          },
          sunday: {
            start: "",
            end: ""
          },
          festive: {
            start: "",
            end: ""
          }
        },
        delivery: "",
        takeaway: {
          monday: {
            start: "",
            end: ""
          },
          tuesday: {
            start: "",
            end: ""
          },
          wednesday: {
            start: "",
            end: ""
          },
          thursday: {
            start: "",
            end: ""
          },
          friday: {
            start: "",
            end: ""
          },
          saturday: {
            start: "",
            end: ""
          },
          sunday: {
            start: "",
            end: ""
          },
          festive: {
            start: "",
            end: ""
          }
        },
        mcexpress: {
          monday: {
            start: "",
            end: ""
          },
          tuesday: {
            start: "",
            end: ""
          },
          wednesday: {
            start: "",
            end: ""
          },
          thursday: {
            start: "",
            end: ""
          },
          friday: {
            start: "",
            end: ""
          },
          saturday: {
            start: "",
            end: ""
          },
          sunday: {
            start: "",
            end: ""
          },
          festive: {
            start: "",
            end: ""
          }
        }
      },
      briefingData: {
        type: "",
        business: "",
        marketing: "",
        target: "",
        date: "",
        budget: ""
      },
      s3Url: process.env.VUE_APP_S3_URL,
      status: { "1": i18n.t("general.state.pending"), "2": i18n.t("general.state.confirmed"), "3": i18n.t("general.state.canceled") }
    };
  },
  computed: {
    channelData() {
      return this.$store.getters["locations/getChannelData"];
    },

    service() {
      return this.$store.getters["locations/getService"];
    },

    serviceData() {
      return this.$store.getters["locations/getServiceData"];
    },

    selectedLocation() {
      return this.$store.getters["locations/getSelectedLocation"];
    },

    formattedZoom() {
      return this.scale == "page-width"
        ? 100
        : Number.parseInt(this.scale * 100);
    },

    user_id() {
      var data = this.$store.getters["user/getUser"];
      return data.id;
    },

    reports() {
      var reports = { ...this.$store.getters["reports/getReports"] };

      if (reports) {
        if (Object.values(reports).length > 0) {
          var sortedReports = Object.values(reports).sort((a, b) => {
            return b.month_formatted.localeCompare(a.month_formatted);
          });
          
          if (this.currentReport === null) {
            this.currentReport = sortedReports[0].id;
          }
          
          return sortedReports;
        }
        return [];
      } else {
        return [];
      }
    },

    checkBirthdayActive() {
      if (this.restaurantService) {
        for (var service_index in this.restaurantService) {
          var service = this.restaurantService[service_index];
          if (
            ((service.slug == "birthday_home" || service.slug == "birthday") &&
              service.status == 1) ||
            this.currentPlannedServices.includes(service.id)
          ) {
            return true;
          }
        }
      }
      return false;
    },
    mopService() {
      var services = Object.values(this.restaurantService || {});

      for (var i = 0; i < services.length; i++) {
        if (services[i].slug === "mop_service") {
          return services[i];
        }
      }

      return false;
    },
    
    currentPlannedSchedule() {
      if (this.plannedSchedules.length > 0 && this.selectedPlannedIndex < this.plannedSchedules.length) {
        return this.plannedSchedules[this.selectedPlannedIndex];
      }
      return null;
    },
    
    currentPlannedDate() {
      return this.currentPlannedSchedule ? this.currentPlannedSchedule.plan_date : false;
    },
    
    currentPlannedServices() {
      return this.currentPlannedSchedule ? this.currentPlannedSchedule.service_planned : [];
    },
    
    currentPlannedScheduleData() {
      return this.currentPlannedSchedule ? this.currentPlannedSchedule.schedules : {};
    },
    
    currentPlannedAllday() {
      return this.currentPlannedSchedule ? this.currentPlannedSchedule.allday : "";
    },
    
    hasMultiplePlannedSchedules() {
      return this.plannedSchedules.length > 1;
    },

    openingMotiveItems() {
      return [
        { value: 1, name: this.$t("views.channels.question.motives.1") },
        { value: 2, name: this.$t("views.channels.question.motives.2") },
        { value: 3, name: this.$t("views.channels.question.motives.3") }
      ];
    }
  },
  methods: {
    openURL(url) {
      window.open(url, "_blank");
    },

    preview(report) {
      window.open(report);
    },

    selectReport(id) {
      if (this.currentReport == id) {
        this.currentReport = null;
      } else {
        this.currentReport = id;
      }
    },

    humanizeDate(date) {
      return moment(date.replace("/", "/01/")).format("MMMM - YYYY");
    },

    tomorrowDate() {
      return moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
    },

    initPlanned() {
      var restaurantService = JSON.parse(
        JSON.stringify(this.restaurantService)
      );
      var servicePlanned = [];
      for (var service_index in restaurantService) {
        var service = restaurantService[service_index];
        if (service.status > 0) {
          servicePlanned.push(service_index);
        }
      }

      var newPlannedSchedule = {
        plan_date: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        service_planned: servicePlanned,
        schedules: JSON.parse(JSON.stringify(this.schedules)),
        allday: this.allday,
        birthday_data: this.birthdayData
      };

      // Add new planned schedule (limit to 2)
      if (this.plannedSchedules.length < 2) {
        this.plannedSchedules.push(newPlannedSchedule);
        this.selectedPlannedIndex = this.plannedSchedules.length - 1;
      } else {
        this.$popup.alert("Máximo 2 cambios programados permitidos");
      }
    },

    addNewPlannedSchedule() {
      if (this.plannedSchedules.length < 2) {
        this.initPlanned();
      } else {
        this.$popup.alert("Máximo 2 cambios programados permitidos");
      }
    },

    removePlannedSchedule(index) {
      var self = this;
      this.$popup.confirm(
        "Eliminar cambio programado",
        "¿Deseas eliminar este cambio programado?",
        "Eliminar",
        "Cancelar",
        function() {
          self.plannedSchedules.splice(index, 1);
          if (self.selectedPlannedIndex >= self.plannedSchedules.length) {
            self.selectedPlannedIndex = Math.max(0, self.plannedSchedules.length - 1);
          }
        }
      );
    },

    selectPlannedSchedule(index) {
      this.selectedPlannedIndex = index;
    },

    orderServices() {
      var services = Object.values(this.service);
      // remove services slug starts by   "mop_"
      services = services.filter(function(service) {
        return !service.slug.startsWith("mop_");
      });
      services.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));
      return services;
    },
    myOrderServices() {
      var services = Object.values(this.service);
      // filter by services slug starts by   "mop"
      services = services.filter(function(service) {
        return service.slug.startsWith("mop_");
      });
      services.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));
      return services;
    },

    allowedStep: m => m % 15 === 0,
    hideMenu: function() {
      this.menuHide = !this.menuHide;
    },

    allDayChangeSchedule(timeframe) {
      timeframe.start = "00:00";
      timeframe.end = "00:00";
    },

    assignData() {
      this.restaurantService = {};
      this.textAllDay = "";
      this.razon = this.channelData.razon;
      this.CIF = this.channelData.CIF;
      this.fiscal_address = this.channelData.fiscal_address;
      this.address = this.channelData.address;
      this.email = this.channelData.email;
      this.type = parseInt(this.channelData.type);
      this.region = parseInt(this.channelData.region);
      this.phone = this.channelData.phone;
      this.mopSchedule = this.channelData.mop_schedule;
      this.pypBlocked = this.channelData.my_order === true;

      if (this.channelData.opening_date == "0") {
        this.temp_opening = "0";
      }
      if (moment(this.channelData.opening_date, "YYYY-MM-DD", true).isValid()) {
        this.temp_opening = "0";
        this.temp_opening_date = moment(
          this.channelData.opening_date,
          "YYYY-MM-DD",
          true
        ).format("YYYY-MM-DD");

        if (
          moment(this.channelData.opening_date, "YYYY-MM-DD", true).diff(
            moment()
          ) < 0
        ) {
          // Past
          this.temp_opening = "1";
        }
      }

      if (this.channelData.channel != null) {
        this.name = this.channelData.channel.name;
        this.log_date = moment(this.channelData.channel.log_date).format(
          "DD/MM/YYYY"
        );
        this.temp_opening_motive = this.channelData.channel.opening_motive;
        this.cv_public = this.channelData.channel.cv_public;
        this.cv_team = this.channelData.channel.cv_team;
        this.startSchedule =
          this.channelData.channel.schedules != undefined
            ? JSON.parse(JSON.stringify(this.channelData.channel.schedules))
            : JSON.parse(JSON.stringify(this.schedulesEmptyTemplate));
        this.schedules =
          this.channelData.channel.schedules != undefined
            ? JSON.parse(JSON.stringify(this.channelData.channel.schedules))
            : JSON.parse(JSON.stringify(this.schedulesEmptyTemplate));

        console.log(this.channelData.channel.birthday_data);

        if (
          this.channelData.channel.birthday_data != undefined &&
          Object.keys(this.channelData.channel.birthday_data).length > 0
        ) {
          this.birthdayData = this.channelData.channel.birthday_data;
          this.birthdayData.book_online = this.birthdayData.hasOwnProperty(
            "book_online"
          )
            ? this.birthdayData.book_online
            : true;
        } else {
          this.birthdayData = {};
          this.birthdayData.book_online = false;
        }
        // this.birthdayData =
        //   this.channelData.channel.birthday_data != undefined
        //     ? this.channelData.channel.birthday_data
        //     : {};

        if (!this.schedules.mcexpress || !this.schedules.mcexpress.monday) {
          this.schedules.mcexpress = JSON.parse(JSON.stringify(this.schedulesEmptyTemplate.mcexpress));
        }
        if (!this.schedules.mcauto || !this.schedules.mcauto.monday) {
          this.schedules.mcauto = JSON.parse(JSON.stringify(this.schedulesEmptyTemplate.mcauto));
        }
        if (!this.schedules.delivery) {
          this.schedules.delivery = this.schedulesEmptyTemplate.delivery;
        }
        if (!this.schedules.takeaway || !this.schedules.takeaway.monday) {
          this.schedules.takeaway = JSON.parse(JSON.stringify(this.schedulesEmptyTemplate.takeaway));
        }
        if (!this.schedules.restaurant || !this.schedules.restaurant.monday) {
          this.schedules.restaurant = JSON.parse(JSON.stringify(this.schedulesEmptyTemplate.restaurant));
        }

        // DELIVERY SCHEDULE TRANSFORM TO MESSAGE
        this.schedules.delivery =
          typeof this.schedules.delivery === "object"
            ? ""
            : this.schedules.delivery;

        this.allday = this.channelData.channel.allday;

        if (
          this.allday != "all" &&
          this.allday != "weekend" &&
          this.allday != "vespers"
        ) {
          this.textAllDay = this.allday;
        }
      } else {
        this.cv_public = 0;
        this.cv_team = 0;
        this.schedules = JSON.parse(JSON.stringify(this.schedulesEmptyTemplate));
        this.allday = "";
      }

      if (this.channelData.channel_plan != null) {
        var rawPlannedSchedules = [];
        if (Array.isArray(this.channelData.channel_plan)) {
          rawPlannedSchedules = JSON.parse(JSON.stringify(this.channelData.channel_plan));
        } else {
          rawPlannedSchedules = [JSON.parse(JSON.stringify(this.channelData.channel_plan))];
        }
        
        // Filter out empty or invalid planned schedules
        this.plannedSchedules = rawPlannedSchedules.filter(function(schedule) {
          return schedule && 
                 typeof schedule === 'object' &&
                 schedule.plan_date && 
                 schedule.plan_date.trim() !== '' &&
                 schedule.service_planned && 
                 Array.isArray(schedule.service_planned) &&
                 schedule.service_planned.length > 0;
        });
        
        this.selectedPlannedIndex = 0;
      }

      this.restaurantService = { ...this.serviceData };
    },

    selectService(item, change_mode) {
      if (change_mode == "planned") {
        if (!this.currentPlannedSchedule) return;
        
        var restaurantService = JSON.parse(
          JSON.stringify(this.currentPlannedSchedule.service_planned)
        );
        if (!restaurantService.includes(item.id)) {
          restaurantService.push(item.id);
        } else {
          restaurantService.splice(restaurantService.indexOf(item.id), 1);
        }

        // logic for push mop service if some mop service is selected
        let mop_service = Object.values(this.serviceData).find(service =>
          service.slug.startsWith("mop_service")
        );
        if (mop_service != undefined && item.slug.startsWith("mop_")) {
          if (
            !restaurantService.includes(mop_service.id) &&
            item.id != mop_service.id
          ) {
            restaurantService.push(mop_service.id);
            this.myOrderShowAlert = true;
          }
        }

        this.changesDetected.plannedService = true;
        this.plannedSchedules[this.selectedPlannedIndex].service_planned = restaurantService;
      } else {
        var restaurantService = JSON.parse(
          JSON.stringify(this.restaurantService)
        );
        if (
          restaurantService == undefined ||
          restaurantService[item.id] == undefined
        ) {
          restaurantService[item.id] = {};
          restaurantService[item.id].id = item.id;
          restaurantService[item.id].status = 0;
          restaurantService[item.id].slug = item.slug;
        }

        restaurantService[item.id].status =
          restaurantService[item.id].status != 1 ? 1 : 0;
        // if slug of item starts with mop_ automatically activate mop_service
        if (
          restaurantService[item.id].slug.startsWith("mop_") &&
          restaurantService[item.id].status == 1
        ) {
          Object.values(restaurantService).forEach(service => {
            if (service.slug == "mop_service") {
              service.status = 1;
              this.myOrderShowAlert = true;
            }
          });
        }
        // if mop_service is deactivated, deactivate all mop_ services
        if (
          item.slug == "mop_service" &&
          restaurantService[item.id].status == 0
        ) {
          Object.values(restaurantService).forEach(service => {
            if (service.slug.startsWith("mop_")) {
              service.status = 0;
              this.myOrderShowAlert = false;
            }
          });
        }

        if (item.slug == "mop_service") {
          this.changesDetected.myorder = true;
        } else {
          this.changesDetected.service = true;
        }
        this.restaurantService = restaurantService;
      }

      this.change = true;
    },

    onPypToggle() {
      if (!this.mopService) {
        return;
      }

      if (this.mopService.status != 1 && this.pypBlocked) {
        this.$popup.alert(this.$t("views.channels.popup.pyp_activation_blocked"));
        return;
      }

      this.selectService(this.mopService, "immediate");
    },

    alldayAction(change_mode) {
      if (change_mode == "planned") {
        this.plannedTextAllDay = "";
        this.change = true;
      } else {
        this.textAllDay = "";
        this.change = true;
      }
    },

    inputErrorCheck(value, service, change_mode) {
      // NEW VALIDATION THAT ONLY VALIDATES FORMAT
      if (
        (value.includes("HH") && !value.includes("mm")) ||
        (value.includes("mm") && !value.includes("HH"))
      ) {
        return true;
      } else return false;

      // OLD VALIDATION
      if (change_mode == "planned") {
        if (this.errorPlannedSchedules) {
          var count = 0;

          for (var index in this.plannedSchedules[service]) {
            var item = this.plannedSchedules[service][index];

            for (var moment in item) {
              var daypart = item[moment];

              if (daypart != "") {
                if (!(daypart.includes("HH") || daypart.includes("mm"))) {
                  count++;
                }
              }
            }
          }

          this.schedulesServicesCount[service] = count;

          if (value != "") {
            if (value.includes("HH") || value.includes("mm")) {
              return true;
            } else return false;
          } else if (
            (this.schedulesServicesCount[service] != 0 &&
              this.schedulesServicesCount[service] != 8) ||
            service == "restaurant"
          ) {
            return true;
          } else return false;
        } else false;
      } else {
        if (this.errorSchedules) {
          var count = 0;

          for (var index in this.schedules[service]) {
            var item = this.schedules[service][index];

            for (var moment in item) {
              var daypart = item[moment];

              if (daypart != "") {
                if (!(daypart.includes("HH") || daypart.includes("mm"))) {
                  count++;
                }
              }
            }
          }

          this.schedulesServicesCount[service] = count;

          if (value != "") {
            if (value.includes("HH") || value.includes("mm")) {
              return true;
            } else return false;
          } else if (
            (this.schedulesServicesCount[service] != 0 &&
              this.schedulesServicesCount[service] != 8) ||
            service == "restaurant"
          ) {
            return true;
          } else return false;
        } else false;
      }
    },

    validateBirthdayData(index) {
      if (this.birthdayData != {} && this.birthdayData.book_online) {
        switch (index) {
          case "bank_account":
          case "bizum":
            // if (
            //   !(
            //     (this.birthdayData["bank_account"] &&
            //       this.birthdayData["bank_account"].trim() != "") ||
            //     (this.birthdayData["bizum"] &&
            //       this.birthdayData["bizum"].trim() != "")
            //   )
            // ) {
            //   this.errorBirthday["paymethod"] = true;
            //   return true;
            // } else {
            //   delete this.errorBirthday["paymethod"];
            //   return false;
            // }
            break;
          case "contact_phone":
          case "contact_mail":
            if (
              !(
                this.birthdayData[index] &&
                this.birthdayData[index].trim() != ""
              )
            ) {
              this.errorBirthday[index] = true;
              return true;
            } else {
              delete this.errorBirthday[index];
              return false;
            }
            break;
          default:
            if (!(this[index] && this[index].trim() != "")) {
              this.errorBirthday[index] = true;
              return true;
            } else {
              delete this.errorBirthday[index];
              return false;
            }
            break;
        }
      }
    },

    validateInfo() {
      // RESET SCHEDULES WARNINGS
      this.errorSchedules = false;
      this.errorPlannedSchedules = false;
      this.checkBirthday = false;

      // CHECK IF IS A CHANGED PLANNED
      if (this.plannedSchedules.length > 0 && this.currentPlannedSchedule) {
        if (!this.isScheduleComplete(this.currentPlannedScheduleData.restaurant)) {
          this.$popup.alert(this.$t("views.channels.popup.incomplete_schedules"));
          this.errorPlannedSchedules = true;
          return false;
        }

        var services = this.service;
        for (var index in this.currentPlannedScheduleData) {
          var item = this.currentPlannedScheduleData[index];
          var count = 0;

          // SPECIAL CASE DELIVERY
          if (index == "delivery") {
            continue;
          }

          // IF DIFERENT OF RESTAURANT TO VALIDATE ALWAYS RESTAURANT SCHEDULE
          if (index != "restaurant") {
            // CHECK IF STATUS IS ACTIVATED
            var service = Object.values(services).filter(obj => {
              return (
                obj.slug == index &&
                this.currentPlannedServices.includes(obj.id)
              );
            });
            if (service.length == 0) {
              // IF SERVICE IS NOT ACTIVE DON'T CONTINUE CHECKING
              continue;
            }

            if (!this.isScheduleComplete(item)) {
              this.$popup.alert(this.$t("views.channels.popup.incomplete_schedules"));
              this.errorPlannedSchedules = true;
              return false;
            }
          }

          for (var subindex in item) {
            var subitem = item[subindex];

            for (var moment in subitem) {
              var daypart = subitem[moment];

              if (daypart != "") {
                if (daypart.includes("HH") || daypart.includes("mm")) {
                  this.$popup.alert(
                    this.$t("views.channels.popup.incomplete_schedules")
                  );
                  this.errorPlannedSchedules = true;
                  return false;
                } else count++;
              }
            }
          }
        }
      }

      var services = this.restaurantService;
      if (this.temp_opening == "0") {
        if (!this.temp_opening_date) {
          this.$popup.alert(
            this.$t("views.channels.popup.closed_restaurant")
          );
          this.errorTemp_opening = true;
          return false;
        }
        if (!this.temp_opening_motive) {
          this.$popup.alert(
            this.$t("views.channels.popup.closed_restaurant_motive")
          );
          this.errorTemp_opening_motive = true;
          return false;
        }
      } else {
        if (!this.isScheduleComplete(this.schedules.restaurant)) {
          this.$popup.alert(this.$t("views.channels.popup.incomplete_schedules"));
          this.errorSchedules = true;
          return false;
        }

        for (var index in this.schedules) {
          var item = this.schedules[index];
          var count = 0;

          // SPECIAL CASE DELIVERY
          if (index == "delivery") {
            continue;
          }

          // IF DIFERENT OF RESTAURANT TO VALIDATE ALWAYS RESTAURANT SCHEDULE
          if (index != "restaurant") {
            // CHECK IF STATUS IS ACTIVATED
            var service = Object.values(services).filter(obj => {
              return obj.slug == index && obj.status == 1;
            });
            if (service.length == 0) {
              // IF SERVICE IS NOT ACTIVE DON'T CONTINUE CHECKING
              continue;
            }

            if (!this.isScheduleComplete(item)) {
              this.$popup.alert(this.$t("views.channels.popup.incomplete_schedules"));
              this.errorSchedules = true;
              return false;
            }
          }

          for (var subindex in item) {
            var subitem = item[subindex];

            for (var moment in subitem) {
              var daypart = subitem[moment];

              if (daypart != "") {
                if (daypart.includes("HH") || daypart.includes("mm")) {
                  this.$popup.alert(
                    this.$t("views.channels.popup.incomplete_schedules")
                  );
                  this.errorSchedules = true;
                  return false;
                } else count++;
              }
            }
          }

          // COMMENTED THE VALIDATION OF FULL FILL OF SCHEDULES
          //   switch (index) {
          //     case "restaurant":
          //       if (count != 8) {
          //         this.$popup.alert(
          //           "Has marcado el restaurante como abierto, solo falta indicar los horarios de apertura"
          //         );
          //         this.errorSchedules = true;
          //         return false;
          //       }
          //       break;
          //     default:
          //       if (count != 8) {
          //         this.$popup.alert(
          //           "El horario que has introducido está incompleto o es incorrecto. Por favor, revísalo antes de guardar"
          //         );
          //         this.errorSchedules = true;
          //         return false;
          //       }
          //       break;
          //   }
        }

        if (Object.values(this.restaurantService).length > 0) {
          var countServices = 0;
          for (var index in this.restaurantService) {
            var item = this.restaurantService[index];
            item.status == 1 ? countServices++ : false;

            if (
              !this.checkBirthday &&
              (item.slug == "birthday_home" || item.slug == "birthday")
            ) {
              if (
                item.status == 1 ||
                this.currentPlannedServices.includes(item.id)
              ) {
                this.checkBirthday = true;
              } else {
                this.checkBirthday = false;
                this.errorBirthday = {};
              }
            }
          }

          if (countServices == 0) {
            this.$popup.alert(
              this.$t("views.channels.popup.open_restaurant")
            );
            return false;
          }
        } else {
          this.$popup.alert(
            this.$t("views.channels.popup.open_restaurant")
          );
          return false;
        }
      }
      if (
        Object.keys(this.errorBirthday).length > 0 &&
        this.birthdayData.book_online
      ) {
        this.$popup.alert(
          this.$t("views.channels.popup.empty_birthday")
        );
        return false;
      }

      return true;
    },

    updateInfo() {
      var self = this;

      var temp_opening = this.temp_opening;

      if (this.temp_opening_date) {
        temp_opening = this.temp_opening_date;
      }

      if (this.temp_opening == "1") {
        temp_opening = "1";
      }

      if (this.validateInfo()) {
        this.$popup.confirm(
          this.$t("views.channels.popup.confirm_title"),
          this.$t("views.channels.popup.confirm_message"),
          this.$t("general.continue"),
          this.$t("general.cancel"),
          function() {
            self.$overlay.loading();
            var aData = {
              restaurant_id: self.selectedLocation.id,
              restaurant_name: self.selectedLocation.name,
              restaurant_site: self.selectedLocation.site,
              razon: self.razon,
              CIF: self.CIF,
              fiscal_address: self.fiscal_address,
              address: self.address,
              email: self.email,
              region: self.region,
              phone: self.phone,
              channel: {
                name: self.name,
                opening_motive: self.temp_opening_motive,
                log_date: moment(self.log_date, "DD/MM/AAAA"),
                cv_public: self.cv_public,
                cv_team: self.cv_team,
                schedules: self.schedules,
                allday: self.allday,
                birthday_data: self.birthdayData
              },
              service: self.restaurantService,
              opening: temp_opening,
              mop_schedule: self.mopNewSchedule
            };

            // Filter out empty or invalid planned schedules
            var validPlannedSchedules = self.plannedSchedules.filter(function(schedule) {
              return schedule && 
                     schedule.plan_date && 
                     schedule.plan_date.trim() !== '' &&
                     schedule.service_planned && 
                     Array.isArray(schedule.service_planned) &&
                     schedule.service_planned.length > 0;
            });

            if (validPlannedSchedules.length > 0) {
              aData.channel_plan = validPlannedSchedules;
            } else {
              aData.channel_plan = null;
            }

            self.$store
              .dispatch("locations/updateChannelData", aData)
              .then(function() {
                self.load = true;
                
                self.$store.dispatch(
                  "locations/loadChannelData",
                  self.selectedLocation.id
                );
                self.$store.dispatch(
                  "locations/loadServiceData",
                  self.selectedLocation.id
                );
                self.mopNewSchedule = [];

                self.$overlay.hide();
                self.updated = true;
                self.change = false;
                self.changesDetected = {};
                self.errorSchedules = false;
                self.errorPlannedSchedules = false;
                setTimeout(function() {
                  self.updated = false;
                }, 5000);
              });
          }
        );
      }
    },

    updateBriefing() {
      if (this.briefingData.type != "") {
        this.$overlay.loading();
        var self = this;
        api
          .post("restaurant/briefing", {
            type: this.briefingData.type,
            business: this.briefingData.business,
            marketing: this.briefingData.marketing,
            target: this.briefingData.target,
            date: this.briefingData.date,
            budget: this.briefingData.budget,
            restaurant_name: this.selectedLocation.name,
            restaurant_site: this.selectedLocation.site,
            phone: this.phone
          })
          .then(function(response) {
            self.$overlay.hide();
            self.$popup.alert(
              this.$t("views.channels.popup.success"),
              function() {}
            );
          });
      }
    },

    /* SIDE MENU SCROLL METHODS */
    anchorNav: function(refName, refChild) {
      if (!refChild) {
        var element = this.$refs[refName];
      } else {
        var element = this.$refs[refName].$refs[refChild];
      }
      var top = element.offsetTop;
      window.scrollTo(0, top - 120);
      this.handleScroll();
    },

    getScroll() {
      if (!this.menuHide) {
        if (this.scrollWait) {
          this.scrollWait = true;
        }
        window.clearTimeout(this.scrolling);

        var self = this;
        this.scrolling = setTimeout(function() {
          self.handleScroll();
          self.scrollWait = false;
        }, 500);
      }
    },

    handleScroll() {
      if (document.getElementsByClassName("active").length > 0) {
        var active = document.getElementsByClassName("active");
        active[0].className = "";
      }
      var element;
      var exitfor = false;
      for (var index in this.$refs) {
        if (
          window.scrollY + 125 >= this.$refs[index].offsetTop &&
          window.scrollY + 125 <=
            this.$refs[index].offsetTop + this.$refs[index].offsetHeight
        ) {
          element = index;
          break;
        }
      }
      document.getElementById(element).className = "active";
    },

    checkChangesBeforeExit: function() {
      if (this.change) {
        return false;
      } else return true;
    },

    /* PDF METHODS */
    doScale(up = true) {
      if (this.scale == "page-width") this.scale = 1;
      if (up) {
        this.scale -= this.scale > 0.2 ? 0.1 : 0;
      } else {
        this.scale += this.scale < 2 ? 0.1 : 0;
      }
    },
    /* getPdfPaid() {
      var self = this;
      self.pdfpaid = pdf.createLoadingTask(self.pdfpaid);
      self.pdfpaid.then(pdf => {
        self.numPagespaid = pdf.numPages;
        window.onscroll = function() {
          // changePage()
          // stickyNav()
        };

        // Get the offset position of the navbar
        /* var sticky = $('#buttons')[0].offsetTop

          // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          function stickyNav() {
            if (window.pageYOffset >= sticky) {
              $('#buttons')[0].classList.remove("hidden")
            } else {
              $('#buttons')[0].classList.add("hidden")
            }
          }

        function changePage() {
          var i = 1;
          var count = Number(pdf.numPages);
          do {
            if (
              window.pageYOffset >= self.findPos(document.getElementById(i)) &&
              window.pageYOffset <= self.findPos(document.getElementById(i + 1))
            ) {
              self.pagepaid = i;
            }
            i++;
          } while (i < count);
          if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
            self.pagepaid = i;
          }
        }
      });
    }, */

    /* getPdfRrss() {
      var self = this;
      self.pdfrrss = pdf.createLoadingTask(self.pdfrrss);
      self.pdfrrss.then(pdf => {
        self.numPagesrrss = pdf.numPages;
        // window.onscroll = function() {
        //   //changePage()
        //   // stickyNav()
        // }

        // Get the offset position of the navbar
        // var sticky = $('#buttons')[0].offsetTop

        // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
        // function stickyNav() {
        //   if (window.pageYOffset >= sticky) {
        //     $('#buttons')[0].classList.remove("hidden")
        //   } else {
        //     $('#buttons')[0].classList.add("hidden")
        //   }
        // }

        function changePage() {
          var i = 1;
          var count = Number(pdf.numPages);
          do {
            if (
              window.pageYOffset >=
                self.findPos(document.getElementById("paid" + i)) &&
              window.pageYOffset <=
                self.findPos(document.getElementById("paid" + (i + 1)))
            ) {
              self.pagerrss = i;
            }
            i++;
          } while (i < count);
          if (
            window.pageYOffset >=
            self.findPos(document.getElementById("paid" + i))
          ) {
            self.pagerrss = i;
          }
        }
      });
    }, */

    findPos(obj) {
      return obj.offsetTop;
    },

    removeMopSchedule(index) {
      /* var self = this
      this.$popup.confirm(
        'Eliminar solicitud',
        '¿Deseas eliminar esta solicitud para deshabilitar temporalmente MyOrder?',
        'Eliminar',
        'Cancelar',
        function () {}
      ) */
      this.mopNewSchedule.splice(index, 1);
    },

    showMopSchedule() {
      this.$overlay.loading();
      this.bShowMopPopup = true;
    },
    cancelMopSchedule() {
      this.$overlay.hide();
      this.bShowMopPopup = false;
    },
    addMopSchedule(params) {
      this.mopNewSchedule.push(params);
      this.$overlay.hide();
      this.bShowMopPopup = false;
      this.changesDetected.myorder = true;
    },
    downloadRRSS() {
      const url = this.pdfrrss;
      const link = document.createElement("a");
      link.href = url;
      link.download = "rrss.pdf"; // Optional: the name to save as
      link.target = "_blank"; // Optional: open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    isScheduleComplete(scheduleDays) {
      if (!scheduleDays || typeof scheduleDays !== "object") return false;
      const requiredDays = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday","festive"];
      for (let i = 0; i < requiredDays.length; i++) {
        const day = scheduleDays[requiredDays[i]];
        if (!day || typeof day !== "object") return false;
        const start = (day.start || "").trim();
        const end = (day.end || "").trim();
        if (
          start === "" || end === "" ||
          start.includes("HH") || start.includes("mm") ||
          end.includes("HH") || end.includes("mm")
        ) {
          return false;
        }
      }
      return true;
    }
  },

  mounted() {
    /* this.getPdfPaid();
    this.getPdfRrss(); */
  },

  watch: {
    selectedLocation: function() {
      var self = this;
      this.load = true;
      this.$store
        .dispatch("locations/loadServiceData", this.selectedLocation.id)
        .then(function() {
          self.$store.dispatch(
            "locations/loadChannelData",
            self.selectedLocation.id
          );
        });
    },

    channelData: function() {
      this.assignData();
    },

    // PDF WATCH
    pagerrss: function(p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
        window.scrollBy(0, -100);
      }
    },

    pagepaid: function(p) {
      if (
        window.pageYOffset <=
          this.findPos(document.getElementById("paid" + p)) ||
        (document.getElementById("paid" + (p + 1)) &&
          window.pageYOffset >=
            this.findPos(document.getElementById("paid" + (p + 1))))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById("paid" + p).scrollIntoView();
        // window.scrollBy(0,-100);
      }
    },

    schedules: {
      handler: function() {
        if (this.load) {
          this.load = false;
        } else {
          this.change = true;

          for (var index in this.schedules) {
            JSON.stringify(this.schedules[index]) !=
            JSON.stringify(this.startSchedule[index])
              ? (this.changesDetected[index] = true)
              : true;
          }
        }
      },
      deep: true
    }
  },

  created() {
    var self = this;
    this.$store.commit("setTitle", this.$t("views.channels.title"));
    this.$store.commit("setMenuVisible", false);

    this.$store.dispatch("locations/loadService");
    console.warn(this.selectedLocation);
    this.$store.dispatch("reports/loadReportsRestaurant", this.selectedLocation.id);
    this.$store
      .dispatch("locations/loadServiceData", this.selectedLocation.id)
      .then(function() {
        self.$store.dispatch(
          "locations/loadChannelData",
          self.selectedLocation.id
        );
      });

    window.addEventListener("scroll", this.getScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },

  beforeRouteLeave(to, from, next) {
    if (this.checkChangesBeforeExit()) {
      next();
    } else {
      var self = this;
      this.$popup.confirm(
        this.$t("views.channels.popup.leave_title"),
        this.$t("views.channels.popup.leave_message"),
        this.$t("general.leave_confirm"),
        this.$t("general.leave_cancel"),
        function() {
          next();
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.preview-pdf {
  overflow: hidden;
  position: relative;
  margin-top: 50px;
  text-align: -webkit-center;
  text-align: -moz-center;

  .pdf-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: #eee;
    z-index: 1;

    .zoom,
    .pages {
      height: 40px;
      width: 50%;
      display: inline-block;
      float: left;
      line-height: 40px;

      .number {
        display: inline-block;
        height: inherit;
        line-height: inherit;
      }
    }
    .btn {
      width: 40px;
      height: 40px;
      display: inline-block;
      background-position: center;
      background-size: 20px;
      background-repeat: no-repeat;

      &.zoom-in {
        background-image: url("/img/more_dark.svg");
      }
      &.zoom-out {
        background-image: url("/img/less_dark.svg");
      }
      &.next {
        background-image: url("/img/right_dark.svg");
      }
      &.prev {
        background-image: url("/img/left_dark.svg");
      }
    }

    .zoom {
      .btn,
      .number {
        float: left;
      }
    }
    .pages {
      .btn,
      .number {
        float: right;
      }
    }
  }

  .pdf-pages {
    /* display: flex;
        flex-direction: column;
        // @include flex-wrap(wrap); // Si hace el wrap se muestra 1 pagina cada vez*/
    /*        position: absolute;*/
    top: 40px;
    left: 0;
    height: calc(100% - 40px);
    width: 100%;
    overflow: auto;
    margin: 0 auto;
    // background-color: #333;

    > div {
      width: auto !important;
    }
  }
}

.paginated {
  position: relative;
  margin-top: 50px;
  height: 560px;
  text-align: -webkit-center;

  .pdf-pages {
    display: flex;
    flex-direction: column;
    /*@include flex-wrap(wrap); // Si hace el wrap se muestra 1 pagina cada vez*/
    position: absolute;
    top: 40px;
    left: 0;
    height: calc(100% - 40px);
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    // background-color: #333;

    > div {
      width: auto !important;
    }
  }
}

.sec-description {
  display: block;
  color: #999;
  margin-bottom: 40px;
}

/* SIDEBAR */
.sidebar-cnt {
  position: fixed;
  left: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 200px;
  height: 80%;

  i {
    color: var(--secondary_color);
  }

  &.hide {
    width: 50px;
  }

  .icon-menu {
    float: left;
    cursor: pointer;

    &.hide {
      transform: rotate(180deg);
    }
  }

  .side-menu {
    width: 200px;
    display: inline-block;
    float: left;
    padding-bottom: 20px;
    height: 95%;
    margin-top: 20px;

    &.hide {
      visibility: hidden;
    }

    #main-menu {
      text-align: left;
      padding: 0;
      border-right: 2px solid var(--secondary_color);

      li {
        cursor: pointer;
        font-size: 18px;
        margin-top: 15px;
        list-style: none;
        width: fit-content;

        &.active {
          color: var(--secondary_color);
          font-weight: bold;
        }
      }

      ul {
        margin: 0 0 0 2em;

        li {
          font-size: 16px;
          margin-top: 5px;
          list-style: circle;
        }
      }
    }
  }
}

/* CONTENT */
.content {
  width: calc(100% - 200px);
  display: inline-block;
  float: right;
  padding: 20px 40px;

  &.hide {
    width: calc(100%);
    transition: 0.2s;
  }

  .section {
    margin: 100px auto;

    .submit {
      width: fit-content;
      margin: 10px auto;
      background-color: var(--secondary_color);
      color: white;
      font-size: 17px;
      padding: 10px 50px;
      border-radius: 50px;
      cursor: pointer;

      &:hover {
        background-color: var(--main_color);
      }
    }
  }

  .mop-status {
    margin-bottom: 50px;
    .value {
      border-radius: 4px;
      margin: 5px 10px;
      padding: 4px 10px;

      &.s1 {
        background-color: #c4eb97;
      }
      &.s2 {
        background-color: #eb9690;
      }
    }
    .action {
      margin-left: 15px;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  #mop-schedule {
    overflow: hidden;
    max-width: 800px;
    margin: 0 auto;

    .mop-item {
      overflow: hidden;
      background-color: #fff;
      border-radius: 4px;
      width: 100%;
      margin: 5px auto;
      border: 2px solid #ccc;

      &.new {
        background-color: #eee;
        border: 0px solid #ccc;
        padding: 20px;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          background-color: #ddd;
        }
      }

      .content {
        display: inline-block;
        width: 100%;
        float: left;
        padding: 10px;

        .col {
          float: left;
          margin-right: 4px;
          width: calc(33.33% - 4px);
          .label {
            width: 100%;
            display: block;
            text-align: left;
          }
          input,
          .value {
            border: 1px solid #999;
            padding: 8px;
            border-radius: 4px;
            background-color: #fff;
            width: 100%;
            padding: 4px;
            border-color: transparent;
            background-color: transparent;
            padding: 0;
            font-weight: bold;
            text-align: left;
            display: inline-block;

            &:disabled {
            }
          }
        }

        .header {
          float: left;
          margin-bottom: 10px;
          text-align: left;
          width: 100%;

          .status {
            background-color: var(--main_color);
            padding: 4px;
            border-radius: 3px;
            margin-right: 10px;
            text-transform: uppercase;

            &.s1 {
              background-color: #ffc107;
            }
            &.s2 {
              background-color: #c4eb97;
            }
            &.s3 {
              background-color: #eb9690;
            }
          }
        }
      }
      .actions {
        display: inline-block;

        .icon {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }

  .title {
    width: auto;

    &.area {
      padding: 30px 0px;
      width: auto;
      font-size: 20px !important;
      background-color: black;
      color: white;
      margin: 35px 0;
      background-color: #eee;
      color: #999;
      margin-bottom: 20px;
      text-transform: uppercase;
    }

    &.subarea {
      background: var(--main_color);
      color: var(--dark_color);
      display: inline-block;
      text-align: center;
      font-size: 19px;
      font-family: Speedee-Bold;
      margin: 0;
      margin-top: 5px;
      padding: 5px 10px;
      margin-bottom: 10px;
      z-index: 1;
      margin-bottom: 10px;
    }
  }
  .title-decription {
    display: flex;
    justify-content: center;
    color: #aaa;
    padding-bottom: 10px;
    font-size: 16px;
    width: 80%;
    margin: 0 auto;

    strong {
      font-family: Speedee-Bold;
      color: inherit;
    }
  }

  .part {
    margin: 30px 0px 40px;
  }

  .reports {
    .g-business {
      display: inline-block;
      width: 160px;
      height: 38px;
      background-image: url("/img/channels/g-business.png");
      background-position: center;
      background-size: contain;
      margin-bottom: -10px;
    }
    .sec-description {
      margin-top: 20px;
      margin-bottom: 15px;
    }

    .reports-box {
      .report {
        width: 100%;
      

        .report-topbar {

          width: 400px;
          text-align: left;
          background-color: #eee;
          padding: 10px;
          margin: 5px auto;

          &:nth-child(odd) {
            background-color: #ddd;
          }
          
          .meta {
            display: inline-block;
            width: 60%;
            cursor: pointer;
            

            .pdf {
              cursor: pointer;
              margin-bottom: -8px;
              display: inline-block;
              background-image: url("/img/pdf.png");
              height: 25px;
              width: 34px;
              background-position: center;
              background-size: contain;
            }
          }

        }

        .report-viewer {
          width: 100%;
          height: 100%;
          border: 1px solid #eee;
          border-radius: 4px;
          padding: 4px;
          height: 70vh;
          margin: 20px auto;
          display: none;;

          &.active  {
            display: block;
          }
        }

        
        .actions {
          width: 40%;
          display: inline-block;
          text-align: right;

          .action {
            color: #3d66ce;
            cursor: pointer;
            // text-decoration: underline;
          }
        }
      }
    }
  }

  .offers {
    .sec-description {
      margin-top: 10px;
      margin-bottom: 15px;
    }
    .prices {
      background-color: var(--secondary_color);
      display: block;
      text-decoration: none;
      color: #fff;
      width: fit-content;
      padding: 8px 30px;
      margin: 0px auto;
      font-size: 16px;
      border-radius: 50px;

      &:hover {
        background-color: var(--main_color);
        color: unset;
      }
    }
  }

  /* MEDIOS PROPIOS */

  .form-section {
    display: block;
    width: 100%;
    border-bottom: 1px solid #ccc;
    text-align: left;
    text-transform: uppercase;
    margin-top: 20px;
    color: #888;
    font-size: 17px;
  }
  .own {
    .alert {
      background-color: #95b5be;
      color: #fff;
      width: fit-content;
      margin: 0 auto;
      height: 0;
      padding: 0;
      overflow: hidden;
      transition: 0.2s;
      border-radius: 3px;

      &.show {
        height: inherit;
        padding: 5px 10px;
        margin: 15px auto;
      }
    }

    .form {
      padding: 20px;
      border-radius: 5px;
    }

    .services {
      margin-top: 50px;

      .title {
        display: block;
        margin: 20px auto;
        width: fit-content;
      }

      .item {
        display: inline-block;
        margin: 10px 0px;
        width: 130px;
        text-align: center;
        padding: 5px;

        .name {
          display: block;
          font-size: 13px;
          margin-top: 5px;
          font-family: Speedee;
          opacity: 1 !important;
          text-transform: uppercase;
          height: 60px;
          overflow: hidden;
          line-height: 17px;
        }

        img {
          width: 62px;
          height: 62px;
          display: block;
          margin: 0 auto;
          cursor: pointer;
          -webkit-filter: grayscale(0%);
          filter: grayscale(0%);
          border-radius: 4px;

          &.disabled {
            opacity: 0.3;
            -webkit-filter: grayscale(100%);
            filter: grayscale(100%);
          }
        }
      }
    }

    .opening {
      border: 0px solid #ccc;
      padding: 15px 20px;
      width: 95%;
      margin: 0px auto 40px auto;
      overflow: hidden;
      text-align: left;
      border-left: 6px solid #004412;
      background: #e6efe8;

      &.closed {
        border-left: 6px solid #d42525;
        background: #ffe2e2;
      }

      .question {
        display: inline-block;
        float: left;
        width: 50%;

        .label {
          float: left;
          padding-top: 10px;
        }
        .v-input--selection-controls {
          float: right;
          margin-top: 0;
          margin-bottom: -12px;
        }
      }

      .open_date {
        display: inline-block;
        float: right;
        width: 30%;
        overflow: hidden;

        .opening_motive {

          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .v-input {
            &.error {
              background-color: transparent !important;
              border: 1px solid red;
            }
          }
        }

        .label {
          float: left;
          width: 50%;
          padding-top: 10px;
        }

                  input {
            border-radius: 3px;
            border: 1px solid #ccc;
            padding: 10px 12px;
            outline: none;
            background: #fff;
            float: left;
            width: 50%;

            &.error {
              background-color: transparent !important;
              border: 1px solid red;
            }
          }

          .v-select {
            float: left;
            width: 50%;
          }
      }
    }
    .help {
      color: #aaa;
      background-color: #fafafa;
      padding-bottom: 10px;
      font-size: 16px;
    }

    .tabs {
      background-color: #fafafa;
      padding-top: 10px;
      align-items: center;
      display: flex;

      .tab {
        padding: 10px 10px;
        width: 50%;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px 15px 0 0;
        font-size: 18px;
        cursor: pointer;
        font-family: Speedee-Bold;
        text-transform: uppercase;
        background-color: #ddd;

        .error-circle {
          border-radius: 100%;
          width: 20px;
          height: 20px;
          display: inline-flex;
          background-color: red;
          margin-right: 10px;
        }

        &.active {
          background-color: var(--main_color);
        }
      }
    }

    .services-box {
      background-color: #fff;
      overflow: hidden;
      padding-bottom: 100px;
      border-radius: 0 0 10px 10px;
      border: 1px solid var(--main_color);

      .part {
        overflow: initial;
        border-radius: 40px !important;
      }

      .plan-date {
        display: inline-block;
        overflow: hidden;

        .label {
          display: inline-flex;
          align-content: center;
          align-items: center;
          font-size: 15px;
          margin-right: 10px;
        }

        input {
          border-radius: 3px;
          border: 1px solid #ccc;
          padding: 3px 12px;
          outline: none;
          background: #fff;
          display: inline-flex;
          align-content: center;
          align-items: center;

          &.error {
            background-color: transparent !important;
            border: 1px solid red;
          }
        }
      }

      .bttn.delete {
        margin: 20px auto 40px;
        width: fit-content;
        padding: 4px 25px;
        font-size: 18px;
        border-radius: 4px;
        cursor: pointer;
        background-color: #d42525;
        color: white;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }

      .bttn.add {
        margin: 20px auto 40px;
        width: fit-content;
        padding: 4px 25px;
        font-size: 18px;
        border-radius: 4px;
        cursor: pointer;
        background-color: var(--secondary_color);
        color: white;
        opacity: 0.8;

        &:hover {
          opacity: 1;
          background-color: var(--main_color);
          color: #333;
        }
      }

      .no-planned {
        padding-top: 20px;
        font-size: 16px;
      }

      .planner {
        margin: 20px auto 40px;
        width: fit-content;
        padding: 4px 25px;
        font-size: 18px;
        border-radius: 4px;
        cursor: pointer;
        background-color: var(--secondary_color);
        color: white;

        &:hover {
          opacity: 1;
          background-color: var(--main_color);
          color: #333;
        }
      }

      .planned-schedules-nav {
        background-color: #f5f5f5;
        padding: 15px;
        margin: 20px auto;
        border-radius: 8px;
        border: 2px solid var(--main_color);

        .nav-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
          color: #333;
        }

        .nav-buttons {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }

        .nav-button {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 15px;
          background-color: #e0e0e0;
          border-radius: 20px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.2s;

          &.active {
            background-color: var(--secondary_color);
            color: white;
          }

          &:hover {
            background-color: var(--main_color);
          }

          .date {
            font-size: 12px;
            opacity: 0.8;
          }

          .remove-icon {
            margin-left: 5px;
            opacity: 0.6;
            cursor: pointer;

            &:hover {
              opacity: 1;
              color: #ff4444;
            }
          }
        }

        .nav-actions {
          display: flex;
          gap: 10px;
          justify-content: center;
          flex-wrap: wrap;

          .bttn {
            display: flex;
            align-items: center;
            gap: 5px;
            width: fit-content;
            padding: 8px 20px !important;
            font-size: 14px !important;
            border-radius: 20px !important;
            cursor: pointer;
            color: white;
            transition: all 0.2s;
            margin: 0 !important;
            opacity: 1 !important;

            &.add {
              background-color: var(--secondary_color) !important;

              &:hover {
                background-color: var(--main_color) !important;
                color: #333 !important;
                opacity: 1 !important;
              }
            }

            &.delete {
              background-color: #d42525 !important;

              &:hover {
                background-color: #b71c1c !important;
                opacity: 1 !important;
              }
            }
          }
        }
      }

      .schedule {
        width: 40%;
        float: left;
        margin: 25px 4.5%;
        min-height: 657px;
        border-radius: 4px;

        .title {
          margin-bottom: 25px;
        }

        /*.align-center {
            margin: 30px auto;
            width: fit-content;
          }*/

        .turn {
          display: block;
          text-align: left;
          margin-top: 50px;
          margin: 5px 5px;
          width: 100%;
          float: left;
          min-width: 600px;

          .name {
            padding: 10px 20px;
            font-size: 16px;
            text-align: left;
            width: 185px;
            border-right: 3px solid #ddd;
            color: #000;
            display: inline-block;
            float: left;

            &.selected {
              background-color: #dadada;
              font-weight: bold;
            }
          }

          .time {
            text-align: center;
            padding: 5px 15px;
            float: left;
            display: inline-block;

            .display-time {
              width: 100px !important;
            }

            .date {
              text-align: center;
              margin: 0 10px;
              max-width: 150px;
              /*font-size: 15px;
                padding: 15px 0px;
                margin: 0px 5px;
                height: 30px;
                background: #fff;
                text-align: center;
                padding: 15px;
                border-radius: 3px;*/

              &.error {
                border: 2px solid #d42525 !important;
                background-color: transparent !important;
              }
            }
            span {
              padding: 0 00px;
              text-align: center;
            }
          }
          .switch {
            margin-top: 5px;
          }
        }
      }
    }

    @media (max-width: 1350px) {
      .schedule {
        min-width: 400px;
        margin: 25px auto;
        float: unset;
        display: inline-table;
      }
    }

    .birthday {
      width: 100%;
      overflow: hidden;
      padding-top: 50px;
      justify-content: center;
      display: inline-grid;

      .title {
        width: fit-content;
        margin: 0 auto;
      }

      .v-text-field {
        &.error {
          background-color: transparent !important;
          border: 2px solid #ff5252;
          border-radius: 3px;
        }
      }
    }

    .full-day {
      width: 100%;
      overflow: hidden;
      padding-top: 50px;
      justify-content: center;
      display: inline-grid;
      margin: 0;

      .title {
        width: fit-content;
        margin: 0 auto;
      }

      .radio-group-full-width {
        width: 100%;
      }
      .options {
        margin-top: 20px;

        .v-input--selection-controls {
          .v-input__control {
            margin: 0 auto !important;
          }
        }

        .option {
          background-color: #ddd;
          overflow: auto;
          display: inline-block;
          margin-right: 20px;
          border-radius: 50px 0px 0px 50px;
          cursor: pointer;

          .box {
            float: left;
            background-color: white;
            width: 50px;
            height: 50px;
            border-radius: 100%;
            border: 1px solid black;

            &.checked {
              background-color: #aaa;
            }
          }

          .name {
            display: inline;
            font-size: 18px;
            float: left;
            padding: 10px 20px;
            height: 50px;
            line-height: 1.8;
          }
        }
      }
    }

    .message {
      width: fit-content;
      margin: 0 auto;
    }

    .save {
      background-color: var(--main_color);
      margin: 10px auto;
      display: block;
      width: fit-content;
      padding: 20px 50px;
      font-size: 18px;
      cursor: pointer;
      font-weight: bold;
      margin-top: 40px;
    }
  }

  /* MEDIOS PAGADOS */
  .paid {
    min-height: 100vh;

    .photo {
      height: 400px;
      width: 60%;
      margin: 0 auto;
      background-image: url("/img/channels/paid.png");
      background-position: center;
      background-size: cover;
    }

    .download {
      font-size: 19px;
      font-family: Speedee;
      width: 60%;
      margin: 0 auto;
      padding: 15px 0px;
      background-color: var(--main_color);
      margin-top: 10px;
      cursor: pointer;

      &:hover {
        font-weight: bold;
      }
    }
  }

  .briefing {
    .submit {
      margin: 10px auto;
      background-color: var(--secondary_color);
      color: white;
      font-size: 17px;
      padding: 10px 50px;
      border-radius: 50px;
      cursor: pointer;

      &:hover {
        background-color: var(--main_color);
      }
    }

    .description {
      text-align: left;
      color: #999;
      font-size: 14px;
      /*width: 50%;*/
      background-color: #eee;
      padding: 5px;
      color: #777;
      font-size: 14px;
    }
  }
}
</style>
